import script from "./FormularioMarcaProducto.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormularioMarcaProducto.vue?vue&type=script&setup=true&lang=ts"

import "./FormularioMarcaProducto.vue?vue&type=style&index=0&id=689a8953&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689a8953"]])

export default __exports__